import React, { ReactNode } from 'react';

import { Helmet } from 'react-helmet';

import { Logo } from 'shared/components/ihcl/icon';

interface SignUpNavTabContainerProps {
  children: ReactNode;
}

const SignUpNavTabContainer = ({ children }: SignUpNavTabContainerProps) => (
  <div className="employer-registration">
    <Helmet>
      <body className="employer employer-registration" />
    </Helmet>
    <div className="sign-up-header w-full px-[15px]">
      <a className="brand-logo" href="/">
        <Logo height="40" />
      </a>
    </div>
    <div className="main-page">
      <div className="mx-auto w-full max-w-[1170px] px-[15px]">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="content-container lg:col-span-8 lg:col-start-3">
            {children}
            <div className="top-separator">
              <div className="divider" />
            </div>
            <div className="top-separator align-center have-account">
              Already have an account?
            </div>
            <div className="align-center bottom-buffer top-buffer">
              <span className="underline-link">
                <a href="/users/sign_in">SIGN IN</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SignUpNavTabContainer;
